var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.333 1.667a.667.667 0 0 0-.667.666v9.057l1.529-1.528a.67.67 0 0 1 .471-.195h8A.666.666 0 0 0 12.333 9V2.333a.666.666 0 0 0-.667-.666zM.919.919A2 2 0 0 1 2.333.333h9.333a2 2 0 0 1 2 2V9a2 2 0 0 1-2 2H3.942l-2.47 2.471A.667.667 0 0 1 .332 13V2.333A2 2 0 0 1 .919.92",
    clipRule: "evenodd"
  })));
};
export default SvgMessage;